(function() {
    'use strict';
    
    const FINANCE_DISPLAY_CLASS = 'finance-added';
    const FINANCE_ELEMENT_CLASS = 'product__info__finance';
    const PRICE_CLASS = 'product__info__price';
    
    let financeData = null;
    let productsData = null;
    let handleToIdMap = new Map();
    let observer = null;
    let jsonMutationObserver = null;
    let observedProductsContainer = null;
    let productsIdSet = new Set();
    let processRunId = 0;
    let candidateQueue = new Set();
    let candidateDebounceTimer = null;
    let candidateFollowupTimer = null;
    
    function getDirectProductChildren() {
        const container = document.getElementById('products');
        if (!container) return [];
        return Array.prototype.slice.call(container.children || []);
    }
    
    function runFinanceProcessing(targets) {
        const elements = Array.isArray(targets) && targets.length ? targets : getDirectProductChildren();
        elements.forEach(function(el) {
            if (!el.classList || !el.classList.contains('finance-added')) {
                addFinanceDisplay(el);
            }
        });
    }
    
    function scheduleCandidateProcessing() {
        if (candidateDebounceTimer) clearTimeout(candidateDebounceTimer);
        candidateDebounceTimer = setTimeout(function() {
            const batch = Array.from(candidateQueue);
            candidateQueue.clear();
            runFinanceProcessing(batch);
            if (candidateFollowupTimer) clearTimeout(candidateFollowupTimer);
            candidateFollowupTimer = setTimeout(function() {
                runFinanceProcessing(batch);
            }, 500);
        }, 120);
    }
    
    function initFinanceDisplay() {
        const jsonElement = document.getElementById('productjson');
        if (!jsonElement) return;
        
        try {
            const data = JSON.parse(jsonElement.textContent);
            if (!data.products_finance) return;
            
            financeData = data.products_finance;
            productsData = data.products;
            // Reset and seed dedupe set on fresh init
            productsIdSet = new Set(Array.isArray(productsData) ? productsData.map(function(p){ return p && p.id; }) : []);
            // Build handle → id map for O(1) lookups
            handleToIdMap = new Map();
            if (Array.isArray(productsData)) {
                productsData.forEach(function(p){ if (p && p.handle) { handleToIdMap.set(p.handle, p.id); } });
            }
            
            // Store globally for debugging
            window.collectionFinanceData = financeData;
            
            setupObserver();
            processExistingProducts();
            
            // Also listen for new collections data being loaded
            watchForDataUpdates();
            
        } catch (error) {
            // Silently fail - no finance data available
            console.warn('Autify finance display error:', error);
        }
    }
    
    function watchForDataUpdates() {
        // Watch for when the productjson script is updated
        const jsonElement = document.getElementById('productjson');
        if (!jsonElement) return;
        
        // Disconnect any previous observer to avoid duplicates
        if (jsonMutationObserver) {
            jsonMutationObserver.disconnect();
            jsonMutationObserver = null;
        }

        jsonMutationObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList' || mutation.type === 'characterData') {
                    try {
                        const newData = JSON.parse(jsonElement.textContent);
                        if (newData.products_finance) {
                            // Merge new finance data with existing (for pagination)
                            financeData = Object.assign({}, financeData || {}, newData.products_finance);
                            // Dedupe products by id
                            const incoming = Array.isArray(newData.products) ? newData.products : [];
                            if (!productsData) productsData = [];
                            incoming.forEach(function(p){
                                if (p && !productsIdSet.has(p.id)) {
                                    productsIdSet.add(p.id);
                                    productsData.push(p);
                                    if (p.handle) handleToIdMap.set(p.handle, p.id);
                                }
                            });
                            window.collectionFinanceData = financeData;
                            
                            // Process any new products that might have been added
                            processExistingProducts();
                        }
                    } catch (e) {
                        // Ignore parse errors
                    }
                }
            });
        });
        
        jsonMutationObserver.observe(jsonElement, {
            childList: true,
            characterData: true,
            subtree: true
        });
    }
    
    // Listen for custom event when products are loaded via AJAX
    window.addEventListener('collectionProductsLoaded', function(event) {
        if (event.detail && event.detail.products) {
            // Update products data
            const incoming = Array.isArray(event.detail.products) ? event.detail.products : [];
            if (!productsData) productsData = [];
            incoming.forEach(function(p){
                if (p && !productsIdSet.has(p.id)) {
                    productsIdSet.add(p.id);
                    productsData.push(p);
                    if (p.handle) handleToIdMap.set(p.handle, p.id);
                }
            });
            
            // If finance data is included in the event, merge it
            if (event.detail.products_finance) {
                financeData = Object.assign({}, financeData || {}, event.detail.products_finance);
                window.collectionFinanceData = financeData;
            }
            
            // Process the new products
            processExistingProducts();
        }
    });
    
    // Intercept XMLHttpRequest to catch AJAX responses  
    // This runs BEFORE init to catch early requests
    (function() {
        const originalOpen = XMLHttpRequest.prototype.open;
        const originalSend = XMLHttpRequest.prototype.send;
        
        XMLHttpRequest.prototype.open = function(method, url, ...rest) {
            this._autifyUrl = url;
            this._autifyMethod = method;
            return originalOpen.apply(this, [method, url, ...rest]);
        };
        
        XMLHttpRequest.prototype.send = function(...args) {
            const xhr = this;
            const url = xhr._autifyUrl;
            
            // Only intercept collection AJAX requests
            if (url && typeof url === 'string' && (url.includes('view=ajax') || url.includes('collections/'))) {
                
                
                // Wrap the response handling
                xhr.addEventListener('load', function() {
                    if (xhr.status === 200) {
                        // Try to parse the response
                        try {
                            const data = JSON.parse(xhr.responseText);
                            if (data.products && data.products_finance) {
                                
                                
                                // Merge finance data
                                if (!financeData) financeData = {};
                                financeData = Object.assign({}, financeData, data.products_finance);
                                
                                if (!productsData) productsData = [];
                                // Dedupe by id when merging from XHR
                                data.products.forEach(function(p){
                                    if (p && !productsIdSet.has(p.id)) {
                                        productsIdSet.add(p.id);
                                        productsData.push(p);
                                        if (p.handle) handleToIdMap.set(p.handle, p.id);
                                    }
                                });
                                
                                window.collectionFinanceData = financeData;
                                
                                // Process the new products after React renders them
                                setTimeout(function() {
                                    
                                    processExistingProducts();
                                }, 800);
                            }
                        } catch (e) {
                            // Parse error - not JSON or malformed
                            console.warn('Autify Finance: Failed to parse AJAX response', e);
                        }
                    }
                });
            }
            
            return originalSend.apply(this, args);
        };
    })();
    
    function setupObserver() {
        const productsContainer = document.getElementById('products');
        // Rebind if container changed (SPA navigation) or not yet observed
        if (observer && observedProductsContainer !== productsContainer) {
            observer.disconnect();
            observer = null;
            observedProductsContainer = null;
        }
        if (observer) return;
        
        observer = new MutationObserver(function(mutations) {
            const container = document.getElementById('products');
            if (!container) return;
            let added = [];
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType !== 1) return;
                    if (!container.contains(node)) return;
                    // Queue direct children of #products (e.g., <li> cards)
                    if (node.parentElement === container) {
                        added.push(node);
                    } else {
                        // If a wrapper was added under #products, capture any new direct children
                        const direct = container.querySelectorAll(':scope > *');
                        if (direct && direct.length) {
                            added = added.concat(Array.prototype.slice.call(direct));
                        }
                    }
                });
            });
            if (added.length) {
                added.forEach(function(el){ candidateQueue.add(el); });
                scheduleCandidateProcessing();
            }
        });
        if (productsContainer) {
            observer.observe(productsContainer, {
                childList: true,
                subtree: true
            });
            observedProductsContainer = productsContainer;
        }
    }
    
    function getProductId(productEl) {
        if (!productsData || !productsData.length) return null;
        
        // Try data-handle attribute
        const productHandle = productEl.getAttribute('data-handle');
        if (productHandle) {
            const mapped = handleToIdMap.get(productHandle);
            if (mapped) return mapped;
            const product = productsData.find(function(p){ return p && p.handle === productHandle; });
            if (product) return product.id;
        }
        
        // Try from link href
        const link = productEl.querySelector('a[href*="/products/"]');
        if (link) {
            const href = link.getAttribute('href');
            const match = href.match(/products\/([^\/]+)/);
            const handle = match ? match[1] : null;
            if (handle) {
                const mapped = handleToIdMap.get(handle);
                if (mapped) return mapped;
                const product = productsData.find(function(p){ return p && p.handle === handle; });
                if (product) return product.id;
            }
        }
        
        return null;
    }
    
    /**
     * Check if product has V12.Disable tag (case-insensitive)
     */
    function isProductFinanceDisabled(productId) {
        if (!productId || !productsData || !productsData.length) return false;
        
        // Find product by ID
        const product = productsData.find(function(p) { 
            return p && (p.id === productId || p.id.toString() === productId.toString()); 
        });
        
        if (product && product.tags && Array.isArray(product.tags)) {
            // Convert all tags to lowercase for case-insensitive comparison
            const tagsLowercase = product.tags.map(function(tag) { 
                return tag.toLowerCase(); 
            });
            // Check if product has "v12.disable" tag (any case variation)
            return tagsLowercase.includes('v12.disable');
        }
        
        return false;
    }
    
    function addFinanceDisplay(productEl) {
        if (!productEl || !financeData) {
           
            return;
        }
        
        // Check if already added
        if (productEl.classList.contains(FINANCE_DISPLAY_CLASS)) {
            
            return;
        }
        
        // Find product info container
        let productInfo = productEl.querySelector('.product__info');
        if (!productInfo) {
            // Fallback: use the product element itself if no inner container
            productInfo = productEl;
        }
        
        // Get product ID
        const productId = getProductId(productEl);
        if (!productId) {
            
            return;
        }
        
        // Check if product has V12.Disable tag - if so, skip adding finance display
        if (isProductFinanceDisabled(productId)) {
            return;
        }
        
        // Get finance text
        const financeText = financeData[productId.toString()] || financeData[productId];
        if (!financeText) {
            
            return;
        }
        
        // Check if finance already added
        let financeEl = productInfo.querySelector('.' + FINANCE_ELEMENT_CLASS);
        
        if (!financeEl) {
            // Create finance element
            financeEl = document.createElement('p');
            financeEl.className = FINANCE_ELEMENT_CLASS;
            financeEl.innerHTML = financeText;
            
            // Find price element to insert below it
            const priceEl = productInfo.querySelector('.' + PRICE_CLASS);
            if (priceEl && priceEl.parentNode) {
                // Insert after price
                priceEl.after(financeEl);
                
            } else {
                // Add to end of product info
                productInfo.appendChild(financeEl);
                
            }
            
            productEl.classList.add(FINANCE_DISPLAY_CLASS);
        }
    }
    
    function processExistingProducts(candidates) {
        // If candidates provided (from mutation batch), process only those plus a short follow-up
        if (Array.isArray(candidates) && candidates.length) {
            runFinanceProcessing(candidates);
            setTimeout(function(){ runFinanceProcessing(candidates); }, 400);
            return;
        }
        // Fallback: initial page load uses original staged timeouts to cover staged rendering
        const runId = ++processRunId;
        [100, 300, 600].forEach(function(delay) {
            setTimeout(function() {
                if (runId !== processRunId) return;
                runFinanceProcessing();
            }, delay);
        });
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFinanceDisplay);
    } else {
        initFinanceDisplay();
    }
    
    
    // Debug: Manual trigger function
    window.autifyFinanceDebug = function() {
        processExistingProducts();
    };
    
})();